class ProductPurchaseBar extends HTMLElement {
  connectedCallback() {
    this.source = document.getElementById(this.getAttribute('for'));
    if (!this.source) return;

    this.root = document.getElementById(this.getAttribute('scroll-root'));
    this.button = document.createElement('button');
    this.button.type = 'button';
    const detailsLink = this.querySelector('a');
    this.replaceChildren(...[this.button, detailsLink].filter(Boolean));
    this.button.addEventListener('click', () => {
      if (this.button.disabled) return;
      this.pending = true;
      this.source.click();
    });

    this.sync = this.sync.bind(this);
    // A fast scroll can jump over the button without an intersection change.
    this.scroller = this.root || window;
    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.sync();
      });
    };
    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
    this.mediaQuery = window.matchMedia('(max-width: 749px)');
    this.mediaQuery.addEventListener('change', this.sync);
    this.intersectionObserver = new IntersectionObserver(this.sync, { root: this.root });
    this.intersectionObserver.observe(this.source);
    this.form = this.source.closest('product-form') || this.source.parentElement;
    this.mutationObserver = new MutationObserver(this.sync);
    this.mutationObserver.observe(this.form, {
      attributes: true, childList: true, characterData: true, subtree: true
    });
    this.sync();
  }

  sync() {
    const rect = this.source.getBoundingClientRect();
    const top = this.root ? this.root.getBoundingClientRect().top : 0;
    const unavailable = this.source.disabled;
    const busy = this.source.getAttribute('aria-disabled') === 'true';
    const label = this.source.textContent.trim();
    if (this.button.textContent !== label) this.button.textContent = label;
    this.button.disabled = unavailable || busy;
    this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
    this.hidden = !this.mediaQuery.matches || unavailable || !rect.height || rect.bottom > top;

    // Cart errors must remain visible when the original form is above the viewport.
    const error = this.form.querySelector('[role="alert"]');
    if (this.pending && error && !error.hidden && error.textContent.trim()) {
      this.pending = false;
      error.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    if (this.wasBusy && !busy) this.pending = false;
    this.wasBusy = busy;
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.frame = null;
    this.pending = false;
    this.wasBusy = false;
    this.scroller?.removeEventListener('scroll', this.onScroll);
    this.intersectionObserver?.disconnect();
    this.mutationObserver?.disconnect();
    this.mediaQuery?.removeEventListener('change', this.sync);
  }
}

customElements.define('product-purchase-bar', ProductPurchaseBar);
